<!-- Ultra Modern Session Warning Dialog -->
@if (show) {
  <div
    class="session-overlay"
    [class.dark-theme]="isDarkTheme"
    [class.light-theme]="!isDarkTheme"
    >
    <!-- Enhanced Backdrop with Blur -->
    <div
      class="backdrop"
    ></div>
    <!-- Main Dialog Card -->
    <div class="dialog-card">
      <!-- Status Bar -->
      <div class="status-bar">
        <div class="status-indicator"></div>
        <span class="status-text">Session Alert</span>
      </div>
      <!-- Content Container -->
      <div class="content-container">
        <!-- Icon and Title Section -->
        <div class="header-section">
          <div class="icon-container">
            <div class="warning-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div class="pulse-ring"></div>
            </div>
            <div class="title-section">
              <h2 class="dialog-title">Session Expiring</h2>
              <p class="dialog-subtitle">Your session will end soon</p>
            </div>
          </div>
          <!-- Countdown Section -->
          <div class="countdown-section">
            <div class="countdown-container">
              <div class="countdown-display">
                <span class="countdown-time">{{
                  sessionService.countdown | async
                }}</span>
              </div>
              <div class="countdown-label">
                <span class="label-text"
                  >Time Remaining ({{ getSessionProgressPercentage() }}%
                  elapsed)</span
                  >
                  <div class="progress-indicator">
                    <!-- DIV Progress Bar -->
                    <div class="progress-bar-container">
                      <div
                        class="progress-fill"
                        [class.warning]="getSessionProgressPercentage() >= 60"
                        [class.critical]="getSessionProgressPercentage() >= 80"
                        [style]="getProgressWidthStyle()"
                        [attr.data-width]="getSessionProgressPercentage() + '%'"
                        [title]="'Progress: ' + getSessionProgressPercentage() + '%'"
                      ></div>
                      <!-- Debug Display -->
                      @if (true) {
                        <div class="progress-debug">
                          {{ getSessionProgressPercentage() }}%
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Message Section -->
            <div class="message-section">
              <p class="warning-message">
                For your security, you'll be automatically signed out when the timer
                reaches zero.
              </p>
              <p class="warning-message">
                You can change your session timer in
                <a
                  href="javascript:void(0)"
                  class="inline-settings-link"
                  (click)="openAdvancedSettings($event)"
                  >Advanced Settings</a
                  >.
                </p>
              </div>
            </div>
            <!-- Action Section -->
            <div class="action-section">
              <button
                (click)="continueSession.emit()"
                class="btn-primary"
                type="button"
                >
                <span class="btn-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span class="btn-text">Continue Session</span>
                </button>
                <button (click)="logout.emit()" class="btn-secondary" type="button">
                  <span class="btn-icon">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4m7 14l5-5-5-5m5 5H9"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <span class="btn-text">Sign Out</span>
                  </button>
                </div>
              </div>
            </div>
          }

